export class FileUtils {
  static toObjectUrl(file: File): string {
    if (!file || typeof file === 'string') {
      return file;
    }
    return URL.createObjectURL(file);
  }

  static downloadFile(file: File) {
    const url = this.toObjectUrl(file);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;

    a.download = file.name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
